import { createSelector } from 'reselect';
import { Map, get } from 'immutable';

const selectFundingSearch = (state) => state.get('fundingSearch');
const selectFundingSearchIdFromProps = (_, props) => get(props, 'fundingSearchId', '');

const makeSelectContactDetails = () =>
  createSelector(selectFundingSearch, (state) => state.get('fundingSearchContactDetails', Map()));

const makeSelectContactDetailsLoading = () =>
  createSelector(
    makeSelectContactDetails(),
    selectFundingSearchIdFromProps,
    (state, fundingSearchId) => state.getIn([fundingSearchId, 'network', 'loading'], false),
  );

const makeSelectContactDetailsData = () =>
  createSelector(
    makeSelectContactDetails(),
    selectFundingSearchIdFromProps,
    (state, fundingSearchId) => state.getIn([fundingSearchId, 'data'], Map()),
  );

export { makeSelectContactDetails, makeSelectContactDetailsLoading, makeSelectContactDetailsData };
